import React from "react";
import ReactDOM from "react-dom";

import firebase from "js/firebase";
import App from "./App";

//
// entry point
//

// debug
window.firebase = firebase;

// firebase
firebase.initializeApp(window.baiFirebase.config);
if (window.baiFirebase.config.measurementId) {
    firebase.analytics();
}

// react
const root = document.createElement("div");
root.id = "react-root";
root.style.display = "contents";
document.body.appendChild(root);

ReactDOM.render(<App />, root);
